import BasicRoute from 'components/routes/BasicRoute'
import React from 'react'
import useAuth from 'useAuth'
import Home from './Home'
import RoutesMenusLogin from './Login'
import PoliticaPrivacidade from './PoliticaPrivacidade'
import News from './News'
import Contact from './Contact'
import RoutesMenusExclusaoDados from './ExclusaoDados'



export default function RoutesMenusPublic() {
    const { isAuthenticated } = useAuth()


    if (isAuthenticated()) {
        return ""
    }
    console.log('Public config')
    return (
        <>
            <RoutesMenusLogin />

            <BasicRoute uid='publicHome' route="" menuProps={{
                text: "Início",
                sequence: "000000",
                iconName: "Home",
            }} element={<Home />} />

            <BasicRoute uid='privacidade' route="privacidade" menuProps={{
                text: "Política de Privacidade",
                sequence: "999999",
                iconName: "Security",
            }} element={<PoliticaPrivacidade />} />

            <BasicRoute
                uid='news'
                route="news"
                menuProps={{
                    text: "Notícias",
                    sequence: "121212",
                    iconName: "Grade",
                }}
                element={<News />}
            />

            <BasicRoute
                uid='contact'
                route="contact"
                menuProps={{
                    text: "Contato",
                    sequence: "212121",
                    iconName: "Call",
                }}
                element={<Contact />}
            />

            <RoutesMenusExclusaoDados />
        </>
    )
}
